import { render, staticRenderFns } from "./AbkLayoutFooter.vue?vue&type=template&id=346a43eb&scoped=true&"
import script from "./AbkLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./AbkLayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./AbkLayoutFooter.vue?vue&type=style&index=0&id=346a43eb&lang=scss&scoped=true&"
import style1 from "./AbkLayoutFooter.vue?vue&type=style&index=1&id=346a43eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a43eb",
  null
  
)

export default component.exports